const text = {
  heading: {
    fontFamily: 'heading',
    lineHeight: 'heading',
    fontWeight: 'heading',
  },
  h1: {
    fontSize: [7, 10],
    fontFamily: 'heading',
    fontWeight: 'light',
  },
  h2: {
    fontSize: [7, 9],
    fontFamily: 'heading',
    fontWeight: 'light',
  },
  h3: {
    fontSize: [7, 8],
    fontFamily: 'heading',
    fontWeight: 'light',
  },
  h4: {
    variant: 'text.heading',
    fontSize: 7,
    fontWeight: 'light',
  },
  h5: {
    variant: 'text.heading',
    fontSize: 5,
    fontWeight: 'normal',
  },
  h6: {
    variant: 'text.heading',
    fontSize: 4,
    fontWeight: 'normal',
  },
  largeText: {
    fontFamily: 'body',
    fontSize: 4,
    fontWeight: 'normal',
  },
  largeTextBold: {
    fontFamily: 'body',
    fontSize: 4,
    fontWeight: 'semiBold',
  },
  mediumText: {
    fontFamily: 'body',
    fontSize: 3,
    fontWeight: 'normal',
  },
  mediumTextBold: {
    fontFamily: 'body',
    fontSize: 3,
    fontWeight: 'semiBold',
  },
  smallText: {
    fontFamily: 'body',
    fontSize: 2,
    fontWeight: 'normal',
  },
  smallTextBold: {
    fontFamily: 'body',
    fontSize: 2,
    fontWeight: 'semiBold',
  },
  xSmallText: {
    fontFamily: 'body',
    fontSize: 1,
    fontWeight: 'normal',
  },
  xxSmallText: {
    fontFamily: 'body',
    fontSize: 0,
    fontWeight: 'normal',
  },
  allCaps: {
    fontFamily: 'body',
    fontSize: 1,
    fontWeight: 'medium',
    textTransform: 'uppercase',
    letterSpacing: '1.07692px',
  },
  allCapsSmall: {
    fontFamily: 'body',
    fontSize: 0,
    fontWeight: 'semiBold',
    textTransform: 'uppercase',
  },
}

export default text
